import { ENABLED_EXTRA_MODULES } from "src/helpers/extra-modules";

export default function useExtraModules() {
  const {
    NETWORK,
    EXTENSIONS,
    RECURRING_TRANSACTIONS,
    VOICE_ASSISTANTS,
    AUTO_UI,
  } = ENABLED_EXTRA_MODULES;

  return {
    myNetworkIsEnabled: NETWORK,
    extensionsIsEnabled: EXTENSIONS,
    recurringTransactionsIsEnabled: RECURRING_TRANSACTIONS,
    voiceAssistantsIsEnabled: VOICE_ASSISTANTS,
    autoUiIsEnabled: AUTO_UI,
  };
}
